@if (lesson(); as currentLesson) {
<div>
  <div>
    <div style="display: flex; gap: 10px; padding: 10px">
      <p-button label="Guardar" severity="primary" (click)="emitSaveRequest()" />
      <p-button label="Importar de Notion" severity="help" (click)="emitImportNotionRequest()" />
      <p-button label="Mejorar Notion con AI" severity="help" (click)="emitImproveNotionRequest()" />
    </div>

    <!-- Use one-way binding and ngModelChange for signals -->
    <div>
      <input
        pInputText
        style="width: 100%"
        [ngModel]="currentLesson.metadata?.title"
        (ngModelChange)="onMetadataPropertyChange('title', $event)"
        type="text"
        placeholder="Agrega un título" />
    </div>
    <div style="margin-top: 4px">
      <p-inputgroup>
        <input
          pInputText
          style="width: 100%"
          [ngModel]="currentLesson.metadata?.description"
          (ngModelChange)="onMetadataPropertyChange('description', $event)"
          type="text"
          placeholder="Agrega una descripción" />
        <p-button
          icon="pi pi-sparkles"
          styleClass="p-button-secondary p-button-outlined"
          pTooltip="Generar descripción con IA"
          tooltipPosition="top"
          [disabled]="isLoadingLesson()"
          (click)="triggerGenerateDescriptionAI()" />
      </p-inputgroup>
    </div>

    <div style="display: flex; align-items: center; margin-top: 10px">
      <input
        pInputText
        style="flex: auto; margin-right: 5px"
        [ngModel]="currentLesson.metadata?.prompt"
        (ngModelChange)="onMetadataPropertyChange('prompt', $event)"
        type="text"
        placeholder="Prompt para IA (opcional)" />
      <p-button severity="primary" label="Generar con IA" icon="pi pi-sparkles" [disabled]="isLoadingLesson()" (click)="generateByAI()" />
    </div>

    <div style="margin-top: 10px">
      <label class="checkbox-container" style="margin-right: 15px">
        <input
          type="checkbox"
          [ngModel]="currentLesson.metadata?.isPublished"
          (ngModelChange)="onMetadataPropertyChange('isPublished', $event)"
          title="Cuando termines la edición marca esta casilla" />
        <span class="checkmark"></span>
        Publicada
      </label>
    </div>

    <p-divider />

    <div style="display: flex; align-items: center; margin-top: 10px; gap: 10px">
      <input
        pInputText
        [ngModel]="currentLesson.appExtension?.['level']"
        (ngModelChange)="onAppExtensionPropChange('level', $event)"
        type="number"
        placeholder="Nivel"
        style="width: 80px" />

      <!-- Access signal values -->
      @if (currentLesson.appExtension) {
      <div>
        {{ currentLesson.appExtension?.['baseLang'] | flagEmoji }} -> {{ currentLesson.appExtension?.['targetLang'] | flagEmoji }} Lección para hablantes de
        {{ currentLesson.appExtension?.['baseLang'] | langDesc : 'es' }} que aprenden
        {{ currentLesson.appExtension?.['targetLang'] | langDesc : 'es' }}
      </div>
      }
    </div>
  </div>
</div>
} @else {
<!-- Optional: Show a loading state or placeholder if lesson is undefined -->
<p>Cargando datos de la lección...</p>
}
